import React from 'react'
import PropTypes from 'prop-types';
import {fetchSearchIfNeeded, selectQuery} from '../../actions'

export class SearchView extends React.Component {

  constructor (props) {
    super(props)
    this.goSearch = this.goSearch.bind(this)
  }

  goSearch (e) {
    e.preventDefault()
    e.stopPropagation()
    const {dispatch, gotoPage} = this.props
    if (this.refs.query.value !== '') {
      dispatch(selectQuery(this.refs.query.value))
      dispatch(fetchSearchIfNeeded(this.refs.query.value))
      this.refs.query.value = ''
      gotoPage('/pesquisa')
    }
  }

  render () {
    const {onChange, customStyle} = this.props
    var clickSubmit = this.goSearch.bind(this)

    return (
      <div id='search-view' className={customStyle} >
        <form onSubmit={clickSubmit}>
          <span>PROCURAR</span>
          <input ref='query' name='query' text='text' onChange={onChange} />
          <p className='searchbtn' onClick={clickSubmit}>
            <i className='glyphicon glyphicon-play'></i>
          </p>
        </form>
      </div>
    )
  }
}

SearchView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  gotoPage: PropTypes.func.isRequired,
  customStyle: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/views/SearchView/SearchView.js